import {
  PeriodGroupByEnum,
  TaskFilterInputObject,
  useSitesPerformanceMetricsByTaskDeadlinesMissedByDateQuery,
  useSitesPerformanceMetricsByTaskResultsByDateQuery,
} from 'graphql-common';
import { StatusKind } from 'routes/Dashboard/Monitoring/enums';

type Args = {
  ids: string[];
  taskFilters?: TaskFilterInputObject[];
  skip?: boolean;
  statusKind?: StatusKind;
};

export default function useSitesPerformanceMetricsByDate({
  ids,
  taskFilters,
  skip,
  statusKind,
}: Args) {
  const filters: TaskFilterInputObject[] = [...(taskFilters || [])];

  const baseOptions = {
    fetchPolicy: 'no-cache' as const,
    variables: {
      ids,
      periodGroupBy: PeriodGroupByEnum.Day,
      taskFilters: filters,
    },
  };

  const missed = useSitesPerformanceMetricsByTaskDeadlinesMissedByDateQuery({
    ...baseOptions,
    skip: !!skip || statusKind !== StatusKind.DeadlineMissed,
  });
  const results = useSitesPerformanceMetricsByTaskResultsByDateQuery({
    ...baseOptions,
    skip: !!skip || statusKind === StatusKind.DeadlineMissed,
  });

  const active = statusKind === StatusKind.DeadlineMissed ? missed : results;
  const { loading, error, refetch, previousData, data } = active as any;
  const queryData = data || previousData;
  const firstLoading = loading && previousData === undefined;
  const raw = (queryData?.data || []) as any[];
  const normalized = Array.isArray(raw)
    ? raw.map((d) => ({
        id: d.id,
        period: d.period,
        totalAnomalies:
          statusKind === StatusKind.DeadlineMissed
            ? d.totalAnomaliesByTaskDeadlinesMissed
            : d.totalAnomaliesByTaskResults,
      }))
    : raw;

  return {
    data: normalized,
    error,
    firstLoading,
    loading,
    refetch,
  };
}
